import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  colors,
  Link
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import axios from 'utils/axios';
import { Label, GenericMoreButton } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  progressContainer: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  arrowForwardIcon: {
    marginRight: theme.spacing(1)
  }
}));

const labelColors = {
  complete: colors.green[600],
  pending: colors.orange[600],
  rejected: colors.red[600]
};

const LatestExams = props => {
  const { className, exams, ...rest } = props;

  const classes = useStyles();

  if(!exams){
    return React.Fragment;
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        // action={<GenericMoreButton />}
        title="آمار تصحیح امتحانات"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar options={{ suppressScrollY: true }}>
          <div className={classes.inner}>
            {exams && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>امتحان</TableCell>
                    <TableCell>ترم</TableCell>
                    <TableCell>توضیحات</TableCell>
                    <TableCell>وضعیت</TableCell>
                    <TableCell align="right">عملیات</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {exams.map(exam => (
                    <TableRow
                      hover
                      key={exam.id}
                    >
                      <TableCell>
                        <div className={classes.nameCell}>
                          <div>
                            <Link
                              color="inherit"
                              component={RouterLink}
                              to={`/exams/${exam.id}` }
                              variant="h6"
                            >
                              {(exam.exam_number == '1' ? 'میان‌ترم' : 'پایان‌ترم') + ' ' + exam.courses[0].name}-گروه {exam.courses.map(function(item) { return item.group; }).join(', ')}
                            </Link>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>{exam.courses[0].semester === 1 ? 'پاییز' : 'زمستان'} {exam.courses[0].year}</TableCell>
                      <TableCell>{exam.name}</TableCell>
                      <TableCell>
                        <Label
                          color={exam.progress === 100 ? colors.green[600]:colors.orange[600]}
                          variant="outlined"
                        >
                          {exam.progress}%
                        </Label>
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/exams/${exam.id}` }
                          variant="outlined"
                        >
                          مشاهده
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          component={RouterLink}
          size="small"
          to="exams"
          variant="text"
        >
          مشاهده همه
          <ArrowBackIcon className={classes.arrowForwardIcon} />
        </Button>
      </CardActions>
    </Card>
  );
};

LatestExams.propTypes = {
  className: PropTypes.string
};

export default LatestExams;
